import React from 'react'
import { ChangePasswordView } from '../../views'
import { Auth0Service, LocalStorageService, UserService } from '../../../services'

class ChangePasswordEmailAction extends React.Component {
    constructor(props) {
        super(props)
        this.props = props
    }

    state = {
        userId: '',
        clientId: '',
        userTypeId: '',
        languageId: '',
        email: '',
        titleUser: '',

        password: '',
        confirmPassword: '',

        changePasswordShowPasswordIcon: 'change-password-input-show-password-icon-desactive',
        changePasswordShowPasswordConfirmIcon: 'change-password-input-show-password-icon-desactive',
        errorForm: false,
        errorMessage: '',

        showLoadingRequesting: false,
        showCompletedRequesting: false,
        showErrorRequesting: false,
    }

    token = {}
    user = {}
    location = {}
    //develop
    url = process.env.REACT_APP_REDIRECT_URI
    //server
    // url = process.env.REACT_APP_MIFIRMA_API
    localStorageService = new LocalStorageService()
    auth0Service = new Auth0Service()
    userService = new UserService(this.url)

    async componentDidMount() {
        this.token = this.props.token
        this.location = this.url;

        this.setState({
            email: this.props.user,
            titleUser: this.props.user
        })
    }

    /**
    * @author Alan Aguilar
    * @description Method to show the loading dialog modal
    * @date 15-12-2020
    * @memberof RegisterUserInvitedAction
    */
    toggleLoadingRequesting = (value) => {
        this.setState({
            showLoadingRequesting: value,
        })
    }

    /**
    * @author Alan Aguilar
    * @description Method to show the complete request dialog modal
    * @date 15-12-2020
    * @memberof RegisterUserInvitedAction
    */
    toggleCompletedRequesting = (value) => {
        this.setState({
            showCompletedRequesting: value,
        },
            () => {
                setTimeout(() => {
                    this.setState({ showCompletedRequesting: false })
                    if (this.props.goToChangePasswordScreen) {
                        this.props.goToChangePasswordScreen()
                    } else if (this.props.redirectToChangePass) {
                        window.location.href = this.location
                        window.location.reload()
                    }
                    else {
                        window.location.reload()
                    }
                }, 1000)
            }
        )
    }

    /**
    * @author Alan Aguilar
    * @description Method to show the Error request dialog modal
    * @date 15-12-2020
    * @memberof RegisterUserInvitedAction
    */
    toggleErrorRequesting = (value) => {
        this.setState({
            showErrorRequesting: value,
        },
            () => {
                setTimeout(() => {
                    this.setState({ showErrorRequesting: false })
                }, 4000)
            }
        )
    }

    /**
    * @author Alan Aguilar
    * @description Handler method to hide and show the label error
    * @date 15-12-2020
    * @memberof AuthService
    */
    onHandleHideError = () => {
        this.setState({
            errorForm: false,
            errorMessage: '',
        })
    }

    /**
    * @author Alan Aguilar
    * @description Handler method to hide and show the password icon and text in Change Password form
    * @date 15-12-2020
    * @memberof AuthService
    */
    onHandleShowPassword = () => {
        let { changePasswordShowPasswordIcon } = this.state
        let inputPassword = document.querySelector('#password')

        if (changePasswordShowPasswordIcon === 'change-password-input-show-password-icon-desactive' && inputPassword.type === 'password') {
            inputPassword.type = 'text'
            this.setState({ changePasswordShowPasswordIcon: 'change-password-input-show-password-icon-active' })
        } else {
            inputPassword.type = 'password'
            this.setState({ changePasswordShowPasswordIcon: 'change-password-input-show-password-icon-desactive' })
        }
    }

    /**
    * @author Alan Aguilar
    * @description Handler method to hide and show the confirmPassword icon and text in Change Password form
    * @date 15-12-2020
    * @memberof AuthService
    */
    onHandleShowPasswordConfirm = () => {
        let { changePasswordShowPasswordConfirmIcon } = this.state
        let inputPassword = document.querySelector('#confirmPassword')

        if (changePasswordShowPasswordConfirmIcon === 'change-password-input-show-password-icon-desactive' && inputPassword.type === 'password') {
            inputPassword.type = 'text'
            this.setState({ changePasswordShowPasswordConfirmIcon: 'change-password-input-show-password-icon-active' })
        } else {
            inputPassword.type = 'password'
            this.setState({ changePasswordShowPasswordConfirmIcon: 'change-password-input-show-password-icon-desactive' })
        }
    }

    /**
    * @author Alan Aguilar
    * @description Handler method for capture the information in all inputs
    * @date 15-12-2020
    * @param {Object} e
    * @memberof AuthService
    */
    onHandleGeneralChange = (e) => {
        this.setState({
            ...this.state,
            [e.target.id]: e.target.value,
        })
    }


    handleButtonLogOut = async () => {
        let logo = await this.localStorageService.getLocalStorageItem('clientLogo')
        let promotion = await this.localStorageService.getLocalStorageItem('promotion')
        await this.localStorageService.clearLocalStorage()
        await this.localStorageService.setLocalStorageItem('clientLogo', logo ? logo : '')
        if (promotion) await this.localStorageService.setLocalStorageItem('promotion', promotion ? promotion : '')
        this.auth0Service.logout()
    }

    /**
    * @author Alan Aguilar
    * @description Method to change the user password in the register invited
    * @date 15-12-2020
    * @memberof RegisterUserInvitedAction
    */
    onSubmitChangeUserPassword = async (t) => {
        let { password, confirmPassword } = this.state
        let regexToValidate = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z])(?=.*[.@#$%^&*!_-])[A-Za-z\d!@#$%^&*._-]{10,16}$/

        let passwordValue = password.trim()
        let confirmPasswordValue = confirmPassword.trim()

        // Validate that both passwors are equal
        if (!(passwordValue === confirmPasswordValue)) {
            this.setState({
                errorForm: true,
                errorMessage: t("login.action.errorPass")
            }, () => {
                setTimeout(() => {
                    this.setState({
                        errorForm: false,
                        errorMessage: ''
                    })
                }, 5000)
            })
            return false
        }

        // Validate if the passwords has more that 8 letters
        if (!passwordValue.match(regexToValidate)) {
            this.setState({
                errorForm: true,
                errorMessage: t("changePasswordView.errorValidPassword"),
            }, () => {
                setTimeout(() => {
                    this.setState({
                        errorForm: false,
                        errorMessage: ''
                    })
                }, 5000)
            })
            return false
        }

        try {
            await this.toggleLoadingRequesting(true)
            const origin = 'internal'
            // Calling service to change password
            let changePassword = await this.auth0Service.forgotPassword(confirmPasswordValue, this.token, origin)
            if (!(Number(changePassword.data.statusCode) === 200)) throw new Error('No se pudo cambiar la contraseña del usuario')

            await this.toggleLoadingRequesting(false)
            await this.toggleCompletedRequesting(true)
            await this.handleButtonLogOut()
        } catch (error) {
            await this.toggleLoadingRequesting(false)
            await this.toggleErrorRequesting(true)
            return false
        }
    }

    render() {
        return (
            <ChangePasswordView
                {...this.state}
                onSubmitChangeUserPassword={this.onSubmitChangeUserPassword}
                onHandleGeneralChange={this.onHandleGeneralChange}
                goToChangePasswordScreen={this.props.goToChangePasswordScreen}
                onHandleShowPassword={this.onHandleShowPassword}
                onHandleShowPasswordConfirm={this.onHandleShowPasswordConfirm}
                onHandleHideError={this.onHandleHideError}
                toggleLoadingRequesting={this.toggleLoadingRequesting}
                toggleCompletedRequesting={this.toggleCompletedRequesting}
                toggleErrorRequesting={this.toggleErrorRequesting}
            />
        )
    }
}
export { ChangePasswordEmailAction as default }